import React, {
    useEffect,
    useState
} from 'react';
import { useDispatch } from 'react-redux';

import { setAppLoading } from '../../app/state/app.actions';
import { LoadingState } from '../../app/state/app.types';
import { IframeStyled } from './iframe.styled';
import { IframeProps } from './iframe.types';

export const Iframe = ({
    iframeSrc,
    ...restProps
}: IframeProps) => {
    const dispatch = useDispatch();
    const [isLoading, setIsLoading] = useState(true);
    const handleOnLoad = () => {
        setIsLoading(false);
    };

    useEffect(() => {
        setIsLoading(true);
    }, [iframeSrc]);

    useEffect(() => {
        // Iframe isLoading state value manages whether we display the content loadingView via redux
        const updatedAppLoading = isLoading ? LoadingState.contentLoading : LoadingState.loaded;

        dispatch(setAppLoading(updatedAppLoading));
    }, [dispatch, isLoading]);

    return (
        <IframeStyled
            key={iframeSrc}
            {...restProps}
            onLoad={handleOnLoad}
            src={iframeSrc}
            id={'iframe'}
        />
    );
};
